import React, { useState, useEffect, useCallback } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { API_URL } from "../../utils/config";
import AjudaCataleg from "./AjudaCataleg";
import { BotoAjuda } from "./AjudaModal";

function Detallscategories({
  mode,
  categoria,
  categories,
  onNavigate,
  onCancel,
  onSave,
  onCanviarMode,
  onDeleted,
}) {
  const { empresaSeleccionada, rolUsuari } = useUserContext();
  TeclaEscEnter(onCancel, null);

  const isReadOnly = mode === "consultar" || mode === "esborrar";
  const [categoriaNom, setCategoriaNom] = useState("");
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const resetForm = useCallback(() => {
    setCategoriaNom("");
  }, []);

  const llista = Array.isArray(categories) ? categories : [];
  const indexActual = categoria
    ? llista.findIndex((c) => Number(c.idCategories) === Number(categoria.idCategories))
    : -1;
  const potNavegar = ["consultar", "modificar"].includes(mode) && llista.length > 1 && indexActual >= 0;

  const anarAnterior = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === 0 ? llista.length - 1 : indexActual - 1;
    onNavigate?.(llista[nouIndex]);
  };

  const anarSeguent = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === llista.length - 1 ? 0 : indexActual + 1;
    onNavigate?.(llista[nouIndex]);
  };

  useEffect(() => {
    if (categoria && (mode === "consultar" || mode === "modificar" || mode === "esborrar")) {
      setCategoriaNom(categoria.Categoria || "");
    } else if (mode === "nou") {
      resetForm();
    }
    setMenuAccions(false);
  }, [categoria, mode, resetForm]);

  const titol =
    mode === "nou"
      ? "Nova categoria"
      : mode === "esborrar"
      ? "Esborrar categoria"
      : mode === "modificar"
      ? "Modificar categoria"
      : "Categories · Fitxa";

  const subtitol =
    mode === "nou"
      ? "Introdueix el nom de la nova categoria."
      : mode === "esborrar"
      ? "Aquesta acció no es pot desfer si no té tipus de material associats."
      : mode === "modificar"
      ? "Edita el nom de la categoria."
      : "Consulta la informació de la categoria.";

  const validarFormulari = () => {
    if (!categoriaNom.trim()) {
      alert("El camp 'Categoria' no pot estar buit.");
      return false;
    }
    if (categoriaNom.trim().length > 45) {
      alert("El nom de la categoria no pot superar 45 caràcters.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (mode !== "esborrar" && !validarFormulari()) return;

    try {
      if (mode === "nou") {
        const response = await fetch(`${API_URL}/Novacategoria.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada?.IdEmpresa,
            Categoria: categoriaNom.trim(),
          }),
        });
        const data = await response.json();
        if (data.success) {
          onSave?.({
            idCategories: data.idCategoria || categoria?.idCategories,
            Categoria: categoriaNom.trim(),
          });
        } else {
          alert(`Error creant Categoria: ${data.message}`);
        }
      } else if (mode === "modificar") {
        const response = await fetch(`${API_URL}/Modificarcategoria.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idCategories: categoria.idCategories,
            Categoria: categoriaNom.trim(),
          }),
        });
        const data = await response.json();
        if (data.success) {
          onSave?.({
            ...categoria,
            Categoria: categoriaNom.trim(),
          });
        } else {
          alert(`Error modificant Categoria: ${data.message}`);
        }
      } else if (mode === "esborrar") {
        const response = await fetch(`${API_URL}/Esborrarcategoria.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idCategories: categoria.idCategories,
          }),
        });
        const data = await response.json();
        if (data.success) {
          onDeleted?.();
        } else {
          alert(`Error esborrant Categoria: ${data.message}`);
        }
      }
    } catch (error) {
      console.error("Error en handleSubmit Categoria:", error);
      alert("S'ha produït un error en el procés.");
    }
  };

  return (
    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {mostraAjuda && <AjudaCataleg pestanya="categories" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "📁"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">{titol}</h1>
            <p className="dv2-pageHeader-subtitle">{subtitol}</p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funcionen les Categories" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && tincPermis(rolUsuari, "MODIFICAR") && (
            <button
              type="button"
              className="dv2-btn dv2-btn--primary"
              onClick={() => onCanviarMode?.("modificar")}
            >
              Modificar
            </button>
          )}
          {mode === "consultar" && tincPermis(rolUsuari, "ESBORRAR") && (
            <div style={{ position: "relative" }}>
              <button
                type="button"
                className="dv2-btn"
                onClick={() => setMenuAccions((v) => !v)}
              >
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  <button
                    type="button"
                    className="dv2-menu-item is-danger"
                    onClick={() => {
                      setMenuAccions(false);
                      onCanviarMode?.("esborrar");
                    }}
                  >
                    Esborrar
                  </button>
                </div>
              )}
            </div>
          )}
          {mode === "nou" || mode === "modificar" ? (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          ) : null}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar categoria
            </button>
          )}
        </div>
      </div>

      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si la categoria té tipus de material associats, el servidor no la deixarà esborrar.
        </div>
      )}

      <div className="dv2-entity-body">
      <section className="dv2-card">
        <div className="dv2-card-head">
          <span className="dv2-card-num">1</span>
          <h2 className="dv2-card-title">Dades bàsiques</h2>
        </div>
        <div className="dv2-fields dv2-fields--sizes">
          <label className="dv2-field dv2-field--llarg">
            <span className={`dv2-label ${isReadOnly ? "" : "dv2-required"}`}>Categoria</span>
            {isReadOnly ? (
              <span className="dv2-value">{categoriaNom || "—"}</span>
            ) : (
              <input
                type="text"
                className="dv2-input"
                value={categoriaNom}
                maxLength={45}
                autoFocus
                onChange={(e) => setCategoriaNom(e.target.value)}
              />
            )}
          </label>
        </div>
      </section>
      </div>

      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarAnterior} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {indexActual + 1} / {llista.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarSeguent} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar categoria
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar categoria" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
  );
}

export default Detallscategories;
